<template>
    <b-modal
        size="lg"
        v-model="mostrarModal"
        no-close-on-backdrop
        @close="fecharModal()"
        @show="preencher()">
        <div slot="modal-title">
            Cronograma de Desembolso -
            <b-badge variant="warning">{{ operacao }}</b-badge>
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12" md="12">
                <b-form-group>
                    <label for="vcDescricao">Descrição</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="vcDescricao"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            A descrição é obrigatória
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="nuParcela">Parcela</label>
                    <b-input-group>
                        <b-form-input
                            type="number"
                            min="1"
                            max="999999"
                            step="1"
                            v-model="nuParcela"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            Parcela é obrigatória
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="dtMesAno">Mês\Ano</label>
                    <b-input-group>
                        <date-picker
                            v-model="dtMesAno"
                            :config="$monthPickerOptions"
                            v-mask="'##/####'"
                        ></date-picker>
                        <b-form-invalid-feedback>
                            Mês\Ano é obrigatório
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group>
                    <label for="nuValorDesembolso">Valor</label>
                    <b-input-group>
                        <money
                            v-model="nuValorDesembolso"
                            v-bind="money"
                            class="form-control text-right"
                        ></money>
                        <b-form-invalid-feedback>
                            Parcela é obrigatória
                        </b-form-invalid-feedback>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                :disabled="this.$v.$invalid"
                @click.stop="salvar()"
                class="ml-1">
                Salvar
            </b-button>
        </div>
    </b-modal>
</template>

<script>

import { required, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        cronogramaDesembolso: Object,
        convenio: Object,
        operacaoProp: String,
        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        erros: {
            type: Array,
            default: () => []
        }
    },

    validations: {
        vcDescricao: { required },
        nuParcela: { required, minValue: minValue(1) },
        dtMesAno: { required },
        nuValorDesembolso: { required, minValue: minValue(0.01) }
    },

    data() {
        return {
            valor: 0,
            codSituacao: null,
            dtLiberacao: null,
            dtMesAno: null,
            idConvenio: 0,
            idCronogramaDesembolso: 0,
            nuParcela: 1,
            nuValorDesembolso: 0,
            percExecucao: null,
            vcDescricao: null,
            vlLiberado: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    computed: {
        operacao() {
            if (this.operacaoProp == 'I') {
                return 'INCLUSÃO'
            }
            return 'ATUALIZAÇÃO'
        }
    },

    methods: {
        preencher() {
            if (this.operacaoProp == 'A') {
                this.vcDescricao = this.cronogramaDesembolso.vcDescricao
                this.nuParcela = this.cronogramaDesembolso.nuParcela
                this.dtMesAno = this.$moment(this.cronogramaDesembolso.dtMesAno).format('MM/YYYY')
                this.nuValorDesembolso = this.cronogramaDesembolso.nuValorDesembolso
            }
        },

        fecharModal() {
            this.$emit('fechar')
            this.resetar()
        },

        salvar() {
            this.$emit('salvar', this.cronogramaDesembolso)
            this.resetar()
        },

        resetar() {
            (this.vcDescricao = null),
            (this.nuParcela = 1),
            (this.dtMesAno = null),
            (this.nuValorDesembolso = 0)
        }
    },

    watch: {
        vcDescricao(novo) {
            this.vcDescricao = novo
            this.cronogramaDesembolso.vcDescricao = this.vcDescricao
        },

        nuParcela(novo) {
            this.nuParcela = novo
            this.cronogramaDesembolso.nuParcela = this.nuParcela
        },

        dtMesAno(novo) {
            this.dtMesAno = novo
            this.cronogramaDesembolso.dtMesAno = this.dtMesAno
        },

        nuValorDesembolso(novo) {
            this.nuValorDesembolso = novo
            this.cronogramaDesembolso.nuValorDesembolso = this.nuValorDesembolso
        }
    }
}
</script>
